import { render, staticRenderFns } from "./event-records-data-table.vue?vue&type=template&id=40d9a782&scoped=true"
import script from "./event-records-data-table.vue?vue&type=script&lang=js"
export * from "./event-records-data-table.vue?vue&type=script&lang=js"
import style0 from "./event-records-data-table.vue?vue&type=style&index=0&id=40d9a782&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d9a782",
  null
  
)

export default component.exports